import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Fleet } from '../types/Fleets';
import { ProfileAPIService } from '../services/AxiosAPIService';
import { FeaturesManagement } from '../../featuresControl';

export const getFleetDetails = async (id: string): Promise<Fleet> => {
  const { data } = await ProfileAPIService.api.get<Fleet>(`/fleets/${id}/info`);
  return data;
};

function useGetFleet(id: string): UseQueryResult<Fleet> {
  return useQuery(
    ['fleet', id],
    async (): Promise<Fleet> => getFleetDetails(id),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
    },
  );
}
export default useGetFleet;
